import {TripCollection} from "../Trip";
import targuSec from "../../../assets/child/targuSec.jpg";

const dayChildTarguSecuiesc: TripCollection = {
    imageSrc: targuSec,
    trips: [
        {
            name: "8.1. Târgu Secuiesc – Valea Zimbrilor",
            route: "Braşov – Vama Buzăului – Târgu Secuiesc – Braşov",
            days: [
                [
                    {
                        locationName: "Rezervaţia de Zimbri",
                    },
                    {
                        locationName: "Muzeul Breslelor",
                    },
                    {
                        locationName: "Atelier de Turtă Dulce",
                    },
                ]
            ],
            notes: "Pornește într-o excursie plină de surprize și descoperiri autentice în inima Transilvaniei. În Rezervația de Zimbri din Vama Buzăului vei fi martor al vieții sălbatice, admirând aceste impresionante animale în habitatul lor natural. La Târgu Secuiesc, Muzeul Breslelor te poartă în lumea meșteșugarilor locali, dezvăluind povești și tradiții păstrate de secole. Experiența se încheie cu un atelier de turtă dulce, unde vei putea să descoperi secretele gustului tradițional și să creezi amintiri dulci, perfecte pentru întreaga familie."
        },
        {
            name: "8.2. Târgu Secuiesc – Lacul Sfânta Ana",
            route:
                "Braşov – Târgu Secuiesc – Lacul Sfânta Ana – Braşov",
            days:
                [
                    [
                        {
                            locationName: "Muzeul Breslelor",
                        },
                        {
                            locationName: "Atelier de Turtă Dulce",
                        },
                        {
                            locationName: "Lacul Sfânta Ana",
                        },
                        {
                            locationName: "Tinovul Mohoş",
                        },
                    ]
                ],
            notes:
                "Pornește într-o excursie de neuitat, care îmbină tradiția, natura și experiențele interactive. La Târgu Secuiesc, Muzeul Breslelor dezvăluie meșteșugurile locale și poveștile meșteșugarilor transilvăneni, iar atelierul de turtă dulce oferă o experiență practică și gustoasă, perfectă pentru întreaga familie. Traseul continuă către Lacul Sfânta Ana, singurul lac vulcanic din România, unde peisajul feeric și liniștea naturii creează momente de relaxare și contemplare. Excursia se încheie la Tinovul Mohoș, o rezervație unică, unde vei descoperi ecosisteme rare și frumusețea sălbatică a zonei."
        }
        ,
        {
            name: "8.3. Târgu Secuiesc – Să învăţăm să facem Kürtőskalács",
            route:
                "Braşov – Târgu Secuiesc – Cernat – Braşov",
            days:
                [
                    [
                        {
                            locationName: "Muzeul Breslelor",
                        },
                        {
                            locationName: "Atelier de Kürtőskalács",
                        },
                        {
                            locationName: "Cetatea Ika",
                        },
                        {
                            locationName: "Muzeul Haszmann Pál",
                        },
                    ]
                ],
            notes:
                "Pornește într-o excursie plină de descoperiri culturale și experiențe interactive în inima Ținutului Secuiesc. La Târgu Secuiesc, Muzeul Breslelor te poartă în lumea meșteșugarilor locali, dezvăluind povești și tradiții păstrate de secole, iar atelierul de Kürtőskalács oferă o experiență practică și gustoasă, perfectă pentru toți participanții. Traseul continuă la Cetatea Ika, o fortificație pitorească ce dezvăluie misterele trecutului, și se încheie la Muzeul Haszmann Pál, care păstrează colecții valoroase despre istoria și cultura zonei. Excursia combină distracția cu învățarea, oferind elevilor momente memorabile și experiențe autentice în Transilvania."
        }
        ,
    ]
}

export default dayChildTarguSecuiesc;